const storageKey = (userId: string) => `peekpass-liked-events:${userId}`;

export const getPersistedLikedEventIds = (userId?: string): string[] => {
  if (!userId || typeof window === 'undefined') return [];
  try {
    const stored = JSON.parse(window.localStorage.getItem(storageKey(userId)) || '[]');
    return Array.isArray(stored) ? stored.map(String) : [];
  } catch {
    return [];
  }
};

export const persistEventLike = (userId: string | undefined, eventId: string, isLiked: boolean) => {
  if (!userId || !eventId || typeof window === 'undefined') return;
  const current = new Set(getPersistedLikedEventIds(userId));
  if (isLiked) current.add(String(eventId));
  else current.delete(String(eventId));
  try {
    window.localStorage.setItem(storageKey(userId), JSON.stringify(Array.from(current)));
  } catch {
    // La API sigue siendo la fuente principal si el navegador bloquea localStorage.
  }
};

export const mergePersistedEventLike = (likes: string[] | undefined, eventId: string, userId?: string) => {
  const merged = new Set((likes || []).map(String));
  if (userId && getPersistedLikedEventIds(userId).includes(String(eventId))) merged.add(String(userId));
  return Array.from(merged);
};
